import styled from 'styled-components';

import { Container } from '#src/atoms/layout/Container/index.tsx';
import { FullWidthContainer } from '#src/atoms/layout/FullWidthContainer/index.tsx';
import { hideScrollbar } from '#src/style/utils.tsx';

export const FullViewportScroll = styled.div`
  ${hideScrollbar}
  display: flex;
  overflow-x: auto;
  overscroll-behavior-x: contain;
  scroll-snap-type: x mandatory;
  ${Container} &, ${FullWidthContainer} & {
    margin: calc(-1 * var(--visible-vertical-overflow-size, 0px))
      calc(-1 * var(--container-padding));
    padding: var(--visible-vertical-overflow-size, 0px) var(--container-padding);
    scroll-padding-inline: var(--container-padding);
  }
`;
